"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.replace");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntlProvider = IntlProvider;
exports.Translate = Translate;
exports.injectIntl = injectIntl;
exports.defineMessages = defineMessages;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var LocaleContext = React.createContext({
  locale: "en",
  messages: {},
  intl: {
    formatMessage: function formatMessage(_ref, values) {
      var id = _ref.id,
          defaultMessage = _ref.defaultMessage;
      return "";
    }
  }
});

function IntlProvider(_ref2) {
  var locale = _ref2.locale,
      messages = _ref2.messages,
      children = _ref2.children;
  return /*#__PURE__*/React.createElement(LocaleContext.Provider, {
    value: {
      locale: locale,
      messages: messages,
      intl: {
        formatMessage: function formatMessage(_ref3, values) {
          var id = _ref3.id,
              defaultMessage = _ref3.defaultMessage;
          var defaultMessageString = !!messages && !!messages[id] ? messages[id] : defaultMessage || "";

          if (!!values) {
            var valKeyArr = Object.keys(values);

            if (Array.isArray(valKeyArr)) {
              valKeyArr.map(function (value) {
                var str = defaultMessageString;
                var res = str.replace("{".concat(value, "}"), values[value]);
                defaultMessageString = res;
              });
            }
          }

          return defaultMessageString;
        }
      }
    }
  }, children);
}

function Translate(_ref4) {
  var id = _ref4.id,
      values = _ref4.values,
      defaultMessage = _ref4.defaultMessage;

  var _React$useContext = React.useContext(LocaleContext),
      messages = _React$useContext.messages;

  return !!messages && !!messages[id] ? messages[id] : defaultMessage || "";
}

function injectIntl(Child) {
  return function (props) {
    return /*#__PURE__*/React.createElement(LocaleContext.Consumer, null, function (_ref5) {
      var intl = _ref5.intl;
      return /*#__PURE__*/React.createElement(Child, _extends({}, props, {
        intl: intl
      }));
    });
  };
}

function defineMessages(messageDescriptors) {
  //console.log('messageDescriptors', messageDescriptors)
  return messageDescriptors;
}